import React, {useEffect, useState} from 'react';
import {connect} from "react-redux";
import logicGraphDataActions from "../../../actions/logicGraphDataActions";
import defaultContextModifierOption
    from "../components/ContextPropertyInputPortList/ContextPropertyModifier/defaultContextModifierOption";

import uniqueId from "lodash/uniqueId";
import {ReactSortable} from "react-sortablejs";

import {InputEntry} from "../components/InputPortListUtils/InputEntry";
import ContentWithTopLabel from "../components/ContentWithTopLabel";
import InputWithLabel from "../components/InputWithLabel";
import {OverwriteDynamicPropertyCheckbox} from "../components/InputPortListUtils/components/OverwriteDynamicPropertyCheckbox";
import {clickedNodeAction} from "../../../actions/clickedNodeActions";
import {AddInputButton} from "../components/InputPortListUtils/components/AddInputButton";
import Predicate from "../components/Predicate";
import ContextPropertyModifier from "../components/ContextPropertyInputPortList/ContextPropertyModifier";

const switchDefaultPredicateOption = defaultContextModifierOption;

import PanelLayout from "../components/PanelLayout";

import {hideModal} from "../../../actions/nodeEditorPanelActions";

const ContextModifierPanel = (props) => {
    const {clickedNodeInfo} = props;

    const nodeOptions = clickedNodeInfo.extras.options;
    const contextModifierInfo = nodeOptions.contextModifierInfo;
    const hasFuncs = nodeOptions && contextModifierInfo;

    const [state, setState] = useState({
        compositeFieldName: hasFuncs ? contextModifierInfo.compositeFieldName : "",
        portList: [],
        options: {
            inputPortData: [],
            logDecisionName: null,
            contextModifierInfo: contextModifierInfo,
            id: clickedNodeInfo.options.id,
            compositeFieldName: hasFuncs ? contextModifierInfo.compositeFieldName : "",
            elementIdAutoIncrement: hasFuncs ? contextModifierInfo.elementIdAutoIncrement : 0,
            shouldOverwriteContextPropertyIfExists: hasFuncs ? contextModifierInfo.shouldOverwriteContextPropertyIfExists : true,
            shouldSuffixContextPropertyIfSplitIsUsed: hasFuncs ? contextModifierInfo.shouldSuffixContextPropertyIfSplitIsUsed : false
        },
        predicate: {
            type: "and",
            predicates: [
                switchDefaultPredicateOption
            ],
            alwaysTrue: true
        },
        modifier: hasFuncs ? (contextModifierInfo.func ? contextModifierInfo.func : contextModifierInfo.modifier) : {
            funcName: "concat",
            funcArgs: []
        },
        elementIdAutoIncrement: hasFuncs ? contextModifierInfo.elementIdAutoIncrement : 0,
        shouldOverwriteContextPropertyIfExists: hasFuncs ? contextModifierInfo.shouldOverwriteContextPropertyIfExists : true,
        shouldSuffixContextPropertyIfSplitIsUsed: hasFuncs ? contextModifierInfo.shouldSuffixContextPropertyIfSplitIsUsed : false
    });

    useEffect(() => {
        createList();
    }, [])

    useEffect(() => {
        createOption();
    }, [state.options.inputPortData])

    const updateProperty = (property, value) => {
        let contextModifierInfo = {...props.clickedNodeInfo}
        if (!Object.prototype.hasOwnProperty.call(contextModifierInfo.extras, "options")) {
            contextModifierInfo.extras.options.contextModifierInfo = {};
        }
        contextModifierInfo.extras.options.contextModifierInfo = {
            ...state,
            [property]: value
        };

        setState({
            ...state,
            options: {
                ...state.options,
                [property]: value
            }
        });

        if (property === "shouldOverwriteContextPropertyIfExists") {
            contextModifierInfo.extras.options.shouldOverwriteContextPropertyIfExists = value;
            contextModifierInfo.extras.options.contextModifierInfo.shouldOverwriteContextPropertyIfExists = value;
            contextModifierInfo.extras.options.contextModifierInfo.options.shouldOverwriteContextPropertyIfExists = value;
        }
        if (property === "shouldSuffixContextPropertyIfSplitIsUsed") {
            contextModifierInfo.extras.options.shouldSuffixContextPropertyIfSplitIsUsed = value;
            contextModifierInfo.extras.options.contextModifierInfo.shouldSuffixContextPropertyIfSplitIsUsed = value;
            contextModifierInfo.extras.options.contextModifierInfo.options.shouldSuffixContextPropertyIfSplitIsUsed = value;
        }
        if (property === "compositeFieldName") {
            contextModifierInfo.extras.options.compositeFieldName = value;
            contextModifierInfo.extras.options.contextModifierInfo.compositeFieldName = value;
            contextModifierInfo.extras.options.contextModifierInfo.options.compositeFieldName = value;
        }
        props.clickedNodeAction(contextModifierInfo);
    }

    const updateOptionFieldName = (property, e) => {
        const value = e.target.value;
        state.compositeFieldName = value;
        updateProperty(property, value)
    }

    const onCheck = (e, propName) => {
        const value = e.target.checked;
        state[propName] = value
        updateProperty(propName, value)
    }

    useEffect(() => {
        updateProperty("shouldOverwriteContextPropertyIfExists", state.shouldOverwriteContextPropertyIfExists);
        onOptionsUpdate("", "", {id: -1})
    }, [state.options.shouldOverwriteContextPropertyIfExists, state.shouldOverwriteContextPropertyIfExists])

    useEffect(() => {
        updateProperty("shouldSuffixContextPropertyIfSplitIsUsed", state.shouldSuffixContextPropertyIfSplitIsUsed);
        onOptionsUpdate("", "", {id: -1})
    }, [state.options.shouldSuffixContextPropertyIfSplitIsUsed, state.shouldSuffixContextPropertyIfSplitIsUsed])


    const onOptionsUpdate = (type, value, item) => {
        let contextModifierInfo = {...props.clickedNodeInfo}

        const updatedItem = item;
        if (type === 'modifier') {
            updatedItem.modifier = value;
        }
        if (type === 'predicate') {
            updatedItem.predicate = value;
        }

        const updatedPortData = state.options.inputPortData.filter(port => port.id !== item.id ? port : item);

        if (!Object.prototype.hasOwnProperty.call(contextModifierInfo.extras, "options")) {
            contextModifierInfo.extras.options = {};
        }
        contextModifierInfo.extras.options.contextModifierInfo = {
            ...state,
            inputPortData: updatedPortData
        };

        setState({
            ...state,
            options: {
                ...state.options,
                inputPortData: updatedPortData
            }
        });

        props.clickedNodeAction(contextModifierInfo);
    }

    const createList = () => {
        const engine = props.logicDataInfo
        const model = engine.getModel();
        const logicData = model.serialize();

        const clickedNodeModifierInfo = {...props.clickedNodeInfo};
        const portList = [];
        const inputPortData = clickedNodeModifierInfo.extras.options.inputPortData;


        Object.values(clickedNodeModifierInfo.ports).forEach((v, i) => {
            const predicate = JSON.parse(JSON.stringify(state.predicate));
            const modifier = JSON.parse(JSON.stringify(state.modifier));
            const values = {
                logDecisionValue: '',
                predicate: predicate,
                modifier: modifier,
                shouldOverwriteContextPropertyIfExists: props.clickedNodeInfo.options.shouldOverwriteContextPropertyIfExists,
                shouldSuffixContextPropertyIfSplitIsUsed: props.clickedNodeInfo.options.shouldSuffixContextPropertyIfSplitIsUsed,
                compositeFieldName: props.clickedNodeInfo.options.compositeFieldName,
            };

            if (typeof inputPortData !== 'undefined' && inputPortData.length > 0 && v.options.in) {
                values.logDecisionValue = typeof inputPortData[i] !== 'undefined' ? inputPortData[i].logDecisionValue : '';
                values.compositeFieldName = typeof inputPortData[i] !== 'undefined' ? inputPortData[i].compositeFieldName : true;
                values.shouldOverwriteContextPropertyIfExists = typeof inputPortData[i] !== 'undefined' ? inputPortData[i].shouldOverwriteContextPropertyIfExists : true;
                values.shouldSuffixContextPropertyIfSplitIsUsed = typeof inputPortData[i] !== 'undefined' ? inputPortData[i].shouldSuffixContextPropertyIfSplitIsUsed : true;
                values.predicate = typeof inputPortData[i] !== 'undefined' ? inputPortData[i].predicate : predicate;
                values.modifier = typeof inputPortData[i] !== 'undefined' ? inputPortData[i].modifier : modifier;
            }

            const createData = {
                parentID: clickedNodeModifierInfo.options.id,
                id: v.options.id,
                nodeName: 'Empty Modifier',
                branchName: '',
                index: 0,
                edit: false,
                sectionType: 'empty',
                logDecisionValue: values.logDecisionValue,
                predicate: values.predicate,
                modifier: values.modifier,
                shouldOverwriteContextPropertyIfExists: values.shouldOverwriteContextPropertyIfExists,
                shouldSuffixContextPropertyIfSplitIsUsed: values.shouldSuffixContextPropertyIfSplitIsUsed,
                compositeFieldName: values.compositeFieldName,
                in: v.options.in
            }

            if (v.connection) {
                let nodeID = '';
                Object.values(logicData.layers.filter(layer => layer.type === 'diagram-links')[0].models).forEach(link => {
                    if (link.sourcePort === v.options.id) {
                        nodeID = link.target;
                    }
                    if (link.targetPort === v.options.id) {
                        nodeID = link.source;
                    }
                });
                const nodeData = Object.values(logicData.layers.filter(layer => layer.type === 'diagram-nodes')[0].models).filter(node => node.id === nodeID)[0]
                createData.nodeName = nodeData.name;
                createData.sectionType = nodeData.sectionType;
                createData.index = i
                portList.push(createData);
            } else {
                createData.index = i;
                portList.push(createData);
            }
        });

        const newPortList = [];
        const inputPortList = portList.filter(port => port.in);
        const outputPortList = portList.filter(port => port.in === false);
        inputPortList.forEach((v, i) => {
            v.index = i;
            newPortList.push(v);
        });
        outputPortList.forEach((v) => {
            newPortList.push(v);
        });

        state.portList = newPortList;
        state.options.inputPortData = inputPortData !== undefined ? inputPortData : [];
        state.compositeFieldName = clickedNodeModifierInfo.extras.options.compositeFieldName;
        state.shouldOverwriteContextPropertyIfExists = clickedNodeModifierInfo.extras.options.shouldOverwriteContextPropertyIfExists;
        state.shouldSuffixContextPropertyIfSplitIsUsed = clickedNodeModifierInfo.extras.options.shouldSuffixContextPropertyIfSplitIsUsed;
    }

    const createOption = () => {
        const inputPortData = Object.values({...state.options.inputPortData});

        const options = {...state.options};
        options.inputPortData = inputPortData;
        options.logDecisionName = props.clickedNodeInfo.extras.options.logDecisionName;
        options.shouldOverwriteContextPropertyIfExists = props.clickedNodeInfo.extras.options.shouldOverwriteContextPropertyIfExists;
        options.shouldSuffixContextPropertyIfSplitIsUsed = props.clickedNodeInfo.extras.options.shouldSuffixContextPropertyIfSplitIsUsed;
        options.compositeFieldName = props.clickedNodeInfo.extras.options.compositeFieldName;

        const logicGraphData = {
            options: options,
            portList: state.portList,
            id: props.clickedNodeInfo.options.id,
            shouldOverwriteContextPropertyIfExists: props.clickedNodeInfo.options.shouldOverwriteContextPropertyIfExists,
            shouldSuffixContextPropertyIfSplitIsUsed: props.clickedNodeInfo.options.shouldSuffixContextPropertyIfSplitIsUsed,
            compositeFieldName: props.clickedNodeInfo.options.compositeFieldName
        }
        props.logicGraphDataActions(logicGraphData);
    }

    const removeInputPort = (item) => {
        const portList = state.options.inputPortData;
        const newInputPortList = portList.filter(port => port.id !== item.id);
        for (let i = 0; i < newInputPortList.length; i++) {
            newInputPortList[i].id = i;
        }
        setState({
            ...state,
            options: {
                ...state.options,
                inputPortData: newInputPortList
            }
        });
    }

    const addModifier = () => {
        const inputPortData = state.options.inputPortData;
        const newModifier = {
            predicate: state.predicate,
            modifier: state.modifier,
            alwaysTrue: false,
            logDecisionValue: '',
            id: inputPortData.length,
            edit: false,
        }
        inputPortData.push(newModifier)

        setState({
            ...state,
            options: {
                ...state.options,
                inputPortData: inputPortData
            },
        });
    }

    const editInputButton = (item) => {
        const setEditValue = editModifierButton(state.options.inputPortData, item);
        setState({
            ...state,
            options: {
                ...state.options,
                inputPortData: setEditValue
            }
        });
    }

    function editModifierButton(portListData, item) {
        const portList = Object.assign({}, portListData);
        return Object.values(portList).map((v) => {
            if (v.id === item.id)
                v.edit = !v.edit;
            return v;
        });
    }

    const inputHandle = (event, item, name) => {
        let process = false;
        const portList = {...state.options.inputPortData};
        const setInputData = Object.values(portList).map((v) => {
            if (v.id === item.id) {
                if (name === 'logDecisionValue' && v.logDecisionValue !== event.target.value) {
                    v.logDecisionValue = event.target.value;
                    process = true;
                }
            }
            return v;
        });
        if (process) {
            setState({
                ...state,
                options: {
                    ...state.options,
                    inputPortData: setInputData
                }
            });
        }
    }

    // constructor(props) {
    //     super(props);
    //
    //     this.hasFuncs = this.props.clickedNodeInfo.extras.options && this.props.clickedNodeInfo.extras.options.contextPropertyModifierInfo;
    //
    //     this.state = {
    //         func: this.hasFuncs ? this.props.clickedNodeInfo.extras.options.contextPropertyModifierInfo.func : {
    //             funcName: "concat",
    //             funcArgs: []
    //         },
    //         compositeFieldName: this.hasFuncs ? this.props.clickedNodeInfo.extras.options.contextPropertyModifierInfo.compositeFieldName : "",
    //         elementIdAutoIncrement: this.hasFuncs ? this.props.clickedNodeInfo.extras.options.contextPropertyModifierInfo.elementIdAutoIncrement : 0,
    //         shouldOverwriteContextPropertyIfExists: this.hasFuncs ? this.props.clickedNodeInfo.extras.options.contextPropertyModifierInfo.shouldOverwriteContextPropertyIfExists : true,
    //         shouldSuffixContextPropertyIfSplitIsUsed: this.hasFuncs ? this.props.clickedNodeInfo.extras.options.contextPropertyModifierInfo.shouldSuffixContextPropertyIfSplitIsUsed : false
    //     };
    //
    //     this.updateProperty = this.updateProperty.bind(this);
    // }

    // updateOptions(func) {
    //     const clickedNodeInfo = this.props.clickedNodeInfo;
    //     let contextPropertyModifierInfo = Object.assign({}, clickedNodeInfo);
    //     if (!Object.prototype.hasOwnProperty.call(contextPropertyModifierInfo.extras, "options")) {
    //         contextPropertyModifierInfo.extras.options = {};
    //     }
    //     contextPropertyModifierInfo.extras.options.contextPropertyModifierInfo = {
    //         ...this.state,
    //         func
    //     }
    //
    //     this.setState({
    //         func: func
    //     });
    //
    //     this.props.clickedNodeAction(contextPropertyModifierInfo);
    // }
    //
    // updateProperty(property, value) {
    //     const clickedNodeInfo = this.props.clickedNodeInfo;
    //     let contextPropertyModifierInfo = Object.assign({}, clickedNodeInfo);
    //     if (!Object.prototype.hasOwnProperty.call(contextPropertyModifierInfo.extras, "options")) {
    //         contextPropertyModifierInfo.extras.options = {};
    //     }
    //     const func = contextPropertyModifierInfo.extras.options.contextPropertyModifierInfo && contextPropertyModifierInfo.extras.options.contextPropertyModifierInfo.func ?
    //         contextPropertyModifierInfo.extras.options.contextPropertyModifierInfo.func : this.state.func;
    //     contextPropertyModifierInfo.extras.options.contextPropertyModifierInfo = {
    //         ...this.state,
    //         [property]: value,
    //         func
    //     }
    //
    //     this.setState({
    //         [property]: value
    //     });
    //
    //     this.props.clickedNodeAction(contextPropertyModifierInfo);
    // }

    // render() {
    //     return (
    //         <PanelLayout>
    //             <ContextPropertyModifier
    //                 updateOptions={(funcName) => this.updateOptions(funcName)}
    //                 func={this.state.func}
    //                 compositeFieldName={this.state.compositeFieldName}
    //                 shouldOverwriteContextPropertyIfExists = {this.state.shouldOverwriteContextPropertyIfExists}
    //                 shouldSuffixContextPropertyIfSplitIsUsed = {this.state.shouldSuffixContextPropertyIfSplitIsUsed}
    //                 updateProperty={this.updateProperty}
    //                 elementIdAutoIncrement={this.state.elementIdAutoIncrement}
    //             />
    //         </PanelLayout>
    //     );
    // }

    const defaultPort = (data) => {
        if (data.length === 0) return [];
        return data.map((val) => {
            return (
                <InputEntry value={val} key={val.id}
                            removePort={removeInputPort}
                            inputHandle={inputHandle}
                            editButton={editInputButton}>
                    <Predicate updateOptions={(predicate) => onOptionsUpdate("predicate", predicate, val)}
                               predicate={val.predicate} hasInputCount predicateBlockType={"context_modifier"}/>
                    <ContextPropertyModifier
                        updateOptions={(funcName) => onOptionsUpdate("modifier", funcName, val)}
                        modifier={val.modifier}
                        updateProperty={updateProperty}
                    />
                </InputEntry>
            )
        })
    }

    const groupCreate = () => {
        const portListData = state.options.inputPortData;

        const roundRobin = portListData.filter(port => port.roundRobin).length > 0 ? 'round-robin' : '';
        return (
            <ReactSortable key="static"
                           animation={150}
                           handle='.drag-handle'
                           group={'default_group' + uniqueId()}
                           pull={true}
                           put={true}

                           list={portListData}
                           setList={(newState) => {
                               if (portListData.length !== newState.length || !portListData.every((val, index) => val === newState[index])) {
                                   const newPortList = [...newState];
                                   newPortList.forEach((val, key) => {
                                       val.id = key;
                                       return val;
                                   });
                                   setState({
                                       ...state,
                                       options: {
                                           ...state.options,
                                           inputPortData: newPortList
                                       }
                                   });
                               }
                           }}
                           className={`list-area ${roundRobin} group-${portListData.length ? portListData[0].groupID : ''}`}
            >
                {defaultPort(portListData)}
            </ReactSortable>
        )
    }

    return (
        <PanelLayout>
            <div>
                <ContentWithTopLabel label="Field name">
                    <InputWithLabel
                        label="New Context property name:"
                        handleChange={e => updateOptionFieldName('compositeFieldName', e)}
                        value={state.compositeFieldName}
                    />
                    <OverwriteDynamicPropertyCheckbox
                        isChecked={state.shouldOverwriteContextPropertyIfExists}
                        onCheck={onCheck}
                        name={"shouldOverwriteContextPropertyIfExists"}
                        label={"Should Overwrite Context Property If Exists"}
                    />
                    <OverwriteDynamicPropertyCheckbox
                        isChecked={state.shouldSuffixContextPropertyIfSplitIsUsed}
                        onCheck={onCheck}
                        name={"shouldSuffixContextPropertyIfSplitIsUsed"}
                        label={"Should Suffix Context Property If Split Is Used"}
                    />
                </ContentWithTopLabel>
                <ContentWithTopLabel label="Modifiers"/>
                <div className="node-input-list">
                    {
                        state.portList && groupCreate()
                    }
                    <AddInputButton onClick={addModifier}/>
                </div>
            </div>
        </PanelLayout>
    )
}

function mapStateToProps(state) {
    return {
        node: state.modalInfo.node,
        clickedNodeInfo: state.clickedNodeInfo,
        logicDataInfo: state.logicDataInfo,
        logicGraphData: state.logicGraphData
    }
}

export default connect(mapStateToProps, {hideModal, logicGraphDataActions, clickedNodeAction})(ContextModifierPanel);